export default "__VITE_ASSET__f4c3c193__"